import Svg from '../generated/Cross';
import { Icon, type IconProps } from './Icon';

export const CrossIcon = (props: IconProps) => <Icon component={Svg} name="cross" {...props} />;
